import DreamupAppContainer from './DreamupApp.container';
import DreamupApp from './DreamupApp';
export default DreamupAppContainer(DreamupApp);
